var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShekelSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 136V344C280 348.422 283.594 352 288 352S296 348.422 296 344V136C296 78.656 249.344 32 192 32H72C49.938 32 32 49.938 32 72V472C32 476.422 35.594 480 40 480S48 476.422 48 472V72C48 58.766 58.781 48 72 48H192C240.531 48 280 87.469 280 136ZM408 32C403.594 32 400 35.578 400 40V376C400 424.531 360.531 464 312 464H192C178.781 464 168 453.234 168 440V168C168 163.578 164.406 160 160 160S152 163.578 152 168V440C152 462.062 169.938 480 192 480H312C369.344 480 416 433.344 416 376V40C416 35.578 412.406 32 408 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShekelSign);
export default __webpack_public_path__ + "static/media/shekel-sign.be261b54fcf3eb92f021ed1cf85cff3b.svg";
export { ForwardRef as ReactComponent };